/**
 * Уроки образовательного курса.
 *
 * Максим 22.08.2026 присылает страницы гайд-инструкции, из них собираются
 * уроки. Содержание пересобрано живым текстом, а не вставлено картинкой:
 * картинку-разворот не прочитать с телефона, а с телефона заходит половина
 * людей. Оригинальный разворот показан рядом как иллюстрация — по нему
 * видно, как то же самое выглядит в печатном гайде.
 *
 * Формат урока: вступление, несколько блоков, вывод. Уроки живут здесь
 * списком, чтобы добавить новый можно было дописав объект, а не заводя
 * ещё одну страницу.
 */

const PUBLIC = process.env.PUBLIC_URL || "";

export const LESSONS = [
  {
    key: "structure",
    n: 1,
    title: "Как устроена платформа",
    lead:
      "Прежде чем собирать свой мир, стоит понять, из чего он складывается. " +
      "Четыре уровня — от проекта до метавселенной.",
    image: `${PUBLIC}/fw/lessons/structure.jpg`,
    imageAlt: "Схема: пользователь, проект, игровые локации, суперлокация",
    minutes: 4,
    blocks: [
      {
        title: "Всё начинается с проекта",
        text:
          "Работа стартует с регистрации и создания проекта. Проект — это папка, " +
          "которая объединяет всё: игровые материалы, настройки и созданные объекты. " +
          "Пока проекта нет, собирать нечего.",
      },
      {
        title: "Внутри проекта — локации",
        text:
          "Локация — самостоятельная игровая сцена. В ней размещаются объекты, задания, " +
          "персонажи, мультимедиа и остальные элементы сценария. Локаций в проекте может " +
          "быть одна, а может быть несколько — это зависит от того, насколько большой мир " +
          "вы задумали.",
      },
      {
        title: "Несколько локаций складываются в суперлокацию",
        text:
          "Суперлокация — единое игровое пространство, метавселенная. Игроки свободно " +
          "переходят между локациями внутри неё, не выходя из игры. Так из отдельных сцен " +
          "получается связный мир.",
      },
      {
        title: "Связи держат мир вместе",
        text:
          "Между локациями создаются логические связи. Они позволяют строить большие миры " +
          "с единым сценарием, общей системой прогресса и сквозной игровой логикой: пройденное " +
          "в одной локации влияет на то, что откроется в другой.",
      },
    ],
    outcome:
      "Теперь вы знаете, из чего состоит мир: проект → локации → суперлокация → связи. " +
      "В следующем уроке разберём, как создаётся игровое задание.",
  },
];

export const lessonByKey = (key) => LESSONS.find((l) => l.key === key) || null;
